// hooks/useSourceIdDeletePermission.js
const useSourceIdDeletePermission = (currentMemberId, sourceId) => {
    return currentMemberId === sourceId;
  };
  
  export default useSourceIdDeletePermission;
  